export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["BIAB004"] = "biab-004";
  ExperimentKeys["GOSU0002"] = "gosu-0002";
  ExperimentKeys["ACQ0136"] = "acqci-acq-0136";
  ExperimentKeys["ACQ0137"] = "acqci-acq-0137";
  ExperimentKeys["ACQ0134"] = "acq01-acq-0134";
  ExperimentKeys["ACQ0138"] = "acq01-acq-0138";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';